export interface PaginatedSearchResult<T> {
  data: T[];
  metadata?: { totalPages?: number };
}

function normalizeTotalPages(raw: unknown): number {
  if (typeof raw !== 'number' || !Number.isFinite(raw) || raw < 1) {
    return 1;
  }
  return Math.floor(raw);
}

/**
 * Carrega todas as páginas de um endpoint paginado usando `metadata.totalPages`.
 * Se `totalPages` vier ausente ou inválido, usa só a primeira página.
 */
export async function fetchAllPages<T>(
  fetchPage: (page: number) => Promise<PaginatedSearchResult<T>>
): Promise<T[]> {
  const firstPage = await fetchPage(1);
  const totalPages = normalizeTotalPages(firstPage.metadata?.totalPages);
  if (totalPages <= 1) {
    return firstPage.data;
  }
  const remaining = await Promise.all(
    Array.from({ length: totalPages - 1 }, (_, i) => fetchPage(i + 2))
  );
  return [...firstPage.data, ...remaining.flatMap((p) => p.data)];
}